export var inmateRequest = function inmateRequest(centralApi, getToken) {
  return {
    get: function get(id) {
      if (id == null) {
        return Promise.resolve(null);
      }
      return centralApi.get("/inmate-request/".concat(id));
    },
    put: function put(inmateRequestId, data) {
      return centralApi.put("/inmate-request/".concat(inmateRequestId), data);
    },
    post: function post(data) {
      return centralApi.post('/inmate-request', data, {
        contentType: false
      });
    },
    postMultiple: function postMultiple(data) {
      return centralApi.post('/inmate-request/multiple', data, {
        contentType: false
      });
    },
    postResponse: function postResponse(inmateRequestId, data) {
      return centralApi.post("/inmate-request/".concat(inmateRequestId, "/response"), data, {
        contentType: false
      });
    },
    deleteAttachment: function deleteAttachment(mailId) {
      return centralApi.delete("/inmate-request/".concat(mailId, "/asset"));
    },
    pdfUrl: function pdfUrl(ids) {
      return centralApi.buildUrl('/inmate-request.pdf', {
        ids: ids,
        includeEmails: true,
        token: getToken().accessToken
      });
    }
  };
};